export default [
    {
        dataName: "totalPR",
        label: "Total PR",
        icon: "ThumbsUpIcon",
        type: "statisticsiconright",
        value: ""
    },
    {
        dataName: "totalPO",
        label: "Total PO",
        icon: "ThumbsUpIcon",
        type: "statisticsiconright",
        value: ""
    },
    {
        dataName: "totalApprovedPR",
        label: "Approved PR",
        icon: "ThumbsUpIcon",
        type: "statistics",
        value: ""
    },
    {
        dataName: "totalPendingPR",
        label: "Pending PR",
        icon: "FilterIcon",
        type: "statistics",
        value: ""
    },
    {
        dataName: "totalRejectedPR",
        label: "Rejected PR",
        icon: "ThumbsDownIcon",
        type: "statistics",
        value: ""
    },
    {
        dataName: "totalApprovedPO",
        label: "Approved PO",
        icon: "ThumbsUpIcon",
        type: "statistics",
        value: ""
    },
    {
        dataName: "totalPendingPO",
        label: "Pending PO",
        icon: "FilterIcon",
        type: "statistics",
        value: ""
    },
    {
        dataName: "totalRejectedPO",
        label: "Rejected PO",
        icon: "ThumbsDownIcon",
        type: "statistics",
        value: ""
    },

    {
        dataName: "totalCLOSEDAmount",
        label: "Total Closed PO Amount",
        icon: "ThumbsUpIcon",
        type: "statisticsiconright",
        value: ""
    }, 

    {
        dataName: "totalCLOSED",
        label: "Total Closed PO",
        icon: "ThumbsDownIcon",
        type: "statistics",
        value: ""
    },
     
]